import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaSubmit: 'Next',
    no: 'No, I did it myself',
    title: 'Did you use a service or third party to create your company?',
    yes: 'Yes, I used a service.',
  },
  fr: {
    ctaSubmit: 'Suivant',
    no: 'Non, j’ai tout fait moi-même',
    title: 'Avez-vous utilisé un service pour créer votre société\u00A0?',
    yes: 'Oui, j’ai fait appel à un autre prestataire',
  },
} as const);
